import { cn } from './chunk-RFTE7DQK.mjs';
import { __objRest, __spreadProps, __spreadValues } from './chunk-3TCQU24P.mjs';
import { forwardRef } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

var ModalAnchor = forwardRef(
  (_a, ref) => {
    var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
    return /* @__PURE__ */ jsxs(
      "div",
      __spreadProps(__spreadValues({
        className: cn(
          "ui-flex ui-p-4 ui-justify-center ui-items-center ui-fixed ui-inset-0 ui-h-screen ui-w-screen ui-z-[999]",
          className
        ),
        ref
      }, props), {
        children: [
          /* @__PURE__ */ jsx("div", { className: "ui-absolute ui-z-[999] ui-inset-0 ui-bg-modal-overlay ui-blur-md ui-bg-no-repeat ui-bg-cover ui-bg-center ui-bg-fixed ui-opacity-70" }),
          children
        ]
      })
    );
  }
);
ModalAnchor.displayName = "ModalAnchor";
function Modal(_a) {
  var _b = _a, {
    className,
    children
  } = _b, props = __objRest(_b, [
    "className",
    "children"
  ]);
  return /* @__PURE__ */ jsx(
    "div",
    __spreadProps(__spreadValues({
      className: cn(
        "ui-relative ui-h-full ui-w-full ui-max-w-[465px] ui-text-black ui-rounded ui-z-[1000] ui-bg-black/25 backdrop-blur-xl",
        className
      )
    }, props), {
      children
    })
  );
}
function ModalClose(_a) {
  var _b = _a, {
    className,
    children
  } = _b, props = __objRest(_b, [
    "className",
    "children"
  ]);
  return /* @__PURE__ */ jsx(
    "button",
    __spreadProps(__spreadValues({
      className: cn(
        "ui-p-2 ui-rounded-lg ui-absolute ui-top-4 ui-right-4 ui-z-[1001] ui-border-none ui-flex ui-items-center ui-justify-center ui-bg-transparent ui-cursor-pointer hover:ui-bg-zinc-100",
        className
      ),
      type: "button"
    }, props), {
      children
    })
  );
}
function ModalSection(_a) {
  var _b = _a, {
    className,
    children
  } = _b, props = __objRest(_b, [
    "className",
    "children"
  ]);
  return /* @__PURE__ */ jsx(
    "div",
    __spreadProps(__spreadValues({
      className: cn(
        "ui-inline-flex ui-w-full ui-h-full ui-flex-col ui-items-start ui-justify-between ui-gap-8",
        className
      )
    }, props), {
      children
    })
  );
}

export { Modal, ModalAnchor, ModalClose, ModalSection };
